module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud_m_v2.d5661ba519518468ba1d128dafe4f631.png";